/**
 * Falls a media element back to its theme asset when the Files copy is not there.
 *
 * The A+ media now lives in Content > Files and is addressed by filename through Liquid's
 * `file_url`. That filter does not report a miss: asked for a name Files has never heard of it
 * still returns a well-formed /cdn/shop/files/<name> URL, which then 404s. So "is this file
 * actually there?" cannot be answered in Liquid, and the fallback has to be taken from the
 * only place that knows — the browser, when the request fails.
 *
 * Each element carries the old assets/ URL in data-aplus-fallback. On the first error the src
 * is swapped and the attribute cleared, so a fallback that also fails cannot loop.
 *
 * Listening in the capture phase is not a style choice: `error` from a media element does not
 * bubble, so a listener on the document only ever sees it on the way down.
 */
(function () {
  if (window.__anzuMediaFallback) return;
  window.__anzuMediaFallback = true;

  function swap(el) {
    var to = el.getAttribute('data-aplus-fallback');
    if (!to) return;
    el.removeAttribute('data-aplus-fallback');

    if (el.tagName === 'SOURCE') {
      /* A <source> that fails does not make the parent try anything else — the parent has
         already exhausted its list. Move the URL onto the video itself and reload it, which
         is the one thing that restarts selection. */
      var media = el.parentNode;
      el.setAttribute('src', to);
      if (media && typeof media.load === 'function') media.load();
      return;
    }
    el.setAttribute('src', to);
  }

  document.addEventListener('error', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    if (el.tagName !== 'IMG' && el.tagName !== 'SOURCE' && el.tagName !== 'VIDEO') return;
    swap(el);
  }, true);

  /* An image that failed before this file was parsed has already fired its error, and a
     listener added afterwards never hears it. `complete` with no naturalWidth is what that
     looks like after the fact, so the same swap is applied once on startup. */
  function sweep() {
    var els = document.querySelectorAll('img[data-aplus-fallback]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.complete && !el.naturalWidth) swap(el);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();
